import React, { Component } from "react";
import _ from "lodash";
import fetcher from "../API/index";
import { Table, message, Space } from 'antd';
import { WEIGHT_SOURCE } from '../common/constants';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

function WeightInput(props) {
    return (
        <div>
            <input type="text" 
            className="form-control"
            placeholder="输入重量值和单位，例如：10 oz"
            value = {props.value}
            onChange={props.onChange}/>
            <div className="mt-2">
                <button className='btn btn-secondary' onClick={props.onCancelClick}>Cancel</button>
                <button className='btn btn-info ml-2' onClick={props.onSaveClick}>Save</button>
            </div>
        </div>
    )
}


class WeightEditor extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isEditing: false,
            selectAll: false,
            selectedSizes: [],
            weights: {},
            inputWeight: '',
            weightInfo: null,
            columns: [],
            dataSource: []
        }
        this.onCheckAllBoxChange = this.onCheckAllBoxChange.bind(this)
        this.onCheckSingleBoxChange = this.onCheckSingleBoxChange.bind(this)
        this.onCancelSave = this.onCancelSave.bind(this)
        this.onSaveWeight = this.onSaveWeight.bind(this)
        this.onEditingWeight = this.onEditingWeight.bind(this)
        this.handleRowSelect = this.handleRowSelect.bind(this);
    }

    componentDidMount() {
        this.loadWeightsFormServer();
        this.getWeightInfo();
    }

    getWeightInfo() {
        fetcher.get(`api/v1/_internal/weight/explain/products/source/${this.props.productId}`)
        .then(res => {
            const weightInfo = res?.data?.productWeights || [];
            const columns = [{
                title: 'size',
                dataIndex: 'sizeName',
                key: 'sizeName',
                align: 'center',
                fixed: 'left'
            }];
            const data = {};
            weightInfo?.forEach(item => {
                columns.push({
                    title: WEIGHT_SOURCE?.[item.weightSource] || item.weightSource,
                    dataIndex: item.weightSource,
                    key: item.weightSource,
                    align: 'center',
                    render: (record, row) => {
                        return <Space>
                            <span>{record}</span>
                            <span>{row[`${item.weightSource}_IN_USE`] ? <CheckOutlined /> : <CloseOutlined />}</span>
                        </Space>
                    }
                })
                item?.skuWeights?.forEach(sku => {
                    data[sku?.sizeName] = {
                        ...data[sku?.sizeName],
                        ...sku,
                        [item.weightSource]: sku?.weight,
                        [`${item.weightSource}_IN_USE`]: sku?.inUse,
                        key: sku?.sizeName
                    }
                })
            })
            this.setState({
                columns,
                dataSource: Object.values(data)
            })
        }).catch(err => {
        })
    }

    onClickEditPencil() {
        this.setState((previousState)=>{
            return {
                isEditing: !previousState.isEditing
            }
        })
    }

    onCheckAllBoxChange(event) {
        if (event.target.checked) {
            const sizes = this.props.sizes.map((size)=>{
                return size.name.toLowerCase();
            })
            this.setState({ 
                selectAll: true,
                selectedSizes: sizes
            })
        }else{
            this.setState({ 
                selectAll: false,
                selectedSizes: []
            })
        }
    }

    onCheckSingleBoxChange(event) {
        const { name, checked } = event.target
        let sizes = this.state.selectedSizes;
        if (checked) {
            sizes = _.union(this.state.selectedSizes, [name.toLowerCase()])
        }else{
            _.remove(sizes, (size)=>{
                return size.toLowerCase() === name.toLowerCase();
            })
        }
        this.setState({selectedSizes: sizes})
    }

    onEditingWeight(e) {
        this.setState({ inputWeight: e.target.value })
    }

    onSaveWeight() {
        this.updateWeightsToServer()
    }

    onCancelSave() {
        this.setState({
            inputWeight: '', 
            isEditing: false,
            selectedSizes: []
        });
    }

    isSizeSelected(sizeName) {
        const checked = _.indexOf(this.state.selectedSizes, sizeName.toLowerCase()) > -1
        return checked
    }

    renderWeightInput() {
        const { isEditing } = this.state;
        return(
            <div>
                {
                    isEditing 
                    ? 
                    <WeightInput 
                        value = { this.state.inputWeight }
                        onChange = { this.onEditingWeight }
                        onSaveClick={ this.onSaveWeight } 
                        onCancelClick={ this.onCancelSave } /> 
                    : <div></div>
                }
            </div>
        )
    }

    renderWeightHeader() {
        return (
            <div className="mb-2">
                <label>重量编辑器</label>
                <span className="oi oi-pencil text-info ml-3 edit-pencil"
                    onClick={ () => this.onClickEditPencil() }>
                </span> 
                { this.renderWeightInput() }
            </div>
        )
    }

    handleRowSelect(event) {
        this.setState({selectedSizes: event})
    }

    render() {
        const { isEditing } = this.state;
        let weight;
        if (this.state.weights[""]) {
            weight = this.state.weights[""];
        }else if (this.state.weights["one size"]) {
            weight = this.state.weights["one size"];
        }else if (this.state.weights["na"]) {
            weight = this.state.weights["na"];
        }else if (this.state.weights["n/a"]) {
            weight = this.state.weights["n/a"];
        }

        const oneSizeEiditor = (
            <div>
                { weight ? weight : '暂无重量信息' }
            </div>  
        )
        const sizeListEditor = (
            <div className="table-responsive">
                <Table
                    rowSelection={isEditing ? {
                        type: 'checkbox',
                        selectedRowKeys: this.state.selectedRowKeys,
                        onChange: this.handleRowSelect
                    } : null}
                    columns={this.state.columns}
                    dataSource={this.state.dataSource}
                    scroll={{x: true}}
                    pagination={false}
                />
            </div>
        )
        const mutipleSize = this.props.sizes && this.props.sizes.length
        return (<div className="col-md-12 mb-1">
            { this.renderWeightHeader() }
            {sizeListEditor}
        </div>)
    }

    loadWeightsFormServer() {
        fetcher.get(`api/v1/product-weights/${this.props.productId}`).then((response)=>{
          const weights =  _.mapKeys(response.data.weights, (value, key)=>{
             return key.toLowerCase();
         })
          this.setState({ weights });
        }).catch((error)=>{
        });
    }

    updateWeightsToServer() {
        let { weights, selectedSizes, inputWeight } = this.state;
        selectedSizes = selectedSizes.filter(item => !!item);
        if(selectedSizes?.length) {
            selectedSizes.forEach(sizeName => {
                weights[sizeName] = inputWeight;
            });
        } else {
            weights[''] = inputWeight;
        }
        this.setState({weights})
        fetcher.post(`api/v1/product-weights/${this.props.productId}`, {
          "weights": weights
        }).then((_)=>{
            this.setState({ isEditing: false })
            this.getWeightInfo();
            message.success('update weight succeed!')
        }).catch((error)=>{
          alert(error);
        });
    }
}

export default WeightEditor